import React from 'react'
import { Button, Modal } from '@mui/material'
import { BiX } from 'react-icons/bi'
import { Alerts, InputText, Loading } from '../../Simple'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import md5 from 'md5'

import './stylesNP.css'

export default function NewPassword({ show, ClosedModal, sttSettings }) {
  const { sttPgStt, inpsStt, actionsSettings } = sttSettings
  const { actionsUCtx, loadsUCtx } = React.useContext(UsuarioContext)

  async function StartRangePass() {
    if (inpsStt.senha === '' || inpsStt.newSenha === '' || inpsStt.confirmSenha === '')
      Alerts.swal('warning', 'Campo vazio', 'Por favor, preencha todos os campos para prosseguir')
    else {
      if (inpsStt.newSenha === inpsStt.confirmSenha) {
        await actionsUCtx.ChangePassUser(md5(inpsStt.senha), md5(inpsStt.newSenha))
        actionsSettings.clearPassInps()
        ClosedModal()
      } else return Alerts.swal('warning', 'Senhas não iguais', 'As senhas não iguais, por favor verifique-as e insira novamente')
    }
  }

  return (
    <Modal open={show} className='contain-overlay-modal-new-pass' onClose={ClosedModal}>
      <div className='contain-content-modal-new-pass'>
        <div className='contain-modal-new-pass'>
          <BiX
            className='icon-close-modal-new-pass'
            size={25}
            onClick={() => {
              ClosedModal()
            }}
          />
          <h1>Alterar Senha</h1>
          {loadsUCtx.updateUserPass ? (
            <div className='contain-loading'>
              <Loading text={'Atualizando senha...'} />
            </div>
          ) : (
            <>
              <InputText
                label={'Senha Atual'}
                placeHolder={'Senha Atual'}
                type={'password'}
                value={inpsStt.senha}
                onKeyDown={e => {
                  if (e.key === 'Enter') StartRangePass()
                }}
                onChange={e => {
                  actionsSettings.handleInpsStt('senha', e.target.value)
                }}
              />
              <InputText
                label={'Nova Senha'}
                placeHolder={'Nova Senha'}
                type={'password'}
                value={inpsStt.newSenha}
                onKeyDown={e => {
                  if (e.key === 'Enter') StartRangePass()
                }}
                onChange={e => {
                  actionsSettings.handleInpsStt('newSenha', e.target.value)
                }}
              />
              <InputText
                label={'Confirmar Senha'}
                placeHolder={'Confirmar Senha'}
                type={'password'}
                value={inpsStt.confirmSenha}
                onKeyDown={e => {
                  if (e.key === 'Enter') StartRangePass()
                }}
                onChange={e => {
                  actionsSettings.handleInpsStt('confirmSenha', e.target.value)
                }}
              />

              {sttPgStt.forca != '' && <label>{sttPgStt.forca}</label>}
              <Button
                variant='contained'
                color='primary'
                className='btn-alterar-senha'
                onClick={() => {
                  StartRangePass()
                }}
              >
                <span>Alterar Senha</span>
              </Button>
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}
